/* @flow */
export { default } from './Icon';

export * from './themes';
